import type { ReactNode, FC, Ref } from "react";
import {
  Button,
  type ChildrenProp,
  Columns,
  ExpenseCard,
  Flex,
  Grid,
  Text,
} from "@huub-web/ui";
import { isArray } from "@huub-web/utils";

import { BidValue } from "./components/BidValue";

import { descriptionStyle, gridStyle } from "./WinningBidCard.css";

export type WinningBidCardContentProps = ChildrenProp & {
  realisticBid?: number | [number, number] | null;
  realisticBidPercentage?: number | [number, number] | null;
  winningBid?: number | [number, number] | null;
  winningBidPercentage?: number | [number, number] | null;
  onWinningBidCTAClick?: () => void;
  bidCTA?: ReactNode;
  winningBidCTA?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const WinningBidCardContent: FC<WinningBidCardContentProps> = ({
  realisticBid,
  realisticBidPercentage,
  winningBid,
  winningBidPercentage,
  winningBidCTA,
  onWinningBidCTAClick,
  disabled,
  bidCTA,
  description = "Huub helpt je bij het bepalen van een realistisch bod én het inschatten van een mogelijk winnend bod (*). Dit doet Huub op basis van slimme data-analyse en actuele marktinformatie.",
  children,
  ref,
}) => {
  const handleCTAClick = () => {
    onWinningBidCTAClick?.();
  };

  return (
    <Flex ref={ref} gap="l" direction="column">
      <Grid variant="none" className={gridStyle}>
        <ExpenseCard
          border="default"
          title="Realistisch bod"
          overflowHidden
          body={
            realisticBidPercentage
              ? `Je biedt **${isArray(realisticBidPercentage) ? realisticBidPercentage.map((value) => `${value > 0 ? "+" : ""}${value}%`).join(" — ") : `${realisticBidPercentage > 0 ? "+" : ""}${realisticBidPercentage}%`} ten opzichte van de vraagprijs**`
              : "Je biedt **?% boven de vraagprijs**"
          }
          titleColor="accent"
          align="center"
          value={<BidValue value={realisticBid} />}
        />
        <ExpenseCard
          align="center"
          border="default"
          title="Winnend bod*"
          overflowHidden
          valueGrow={!winningBidCTA && !onWinningBidCTAClick}
          body={
            winningBidCTA ? (
              <Flex grow justify="center">
                {winningBidCTA}
              </Flex>
            ) : onWinningBidCTAClick ? (
              <Flex grow justify="center">
                <Button
                  size="s"
                  variant="primary"
                  onClick={handleCTAClick}
                  disabled={disabled}
                  alignSelf="center"
                >
                  Bespreek met adviseur
                </Button>
              </Flex>
            ) : winningBidPercentage ? (
              `Je biedt **${isArray(winningBidPercentage) ? winningBidPercentage.map((value) => `${value > 0 ? "+" : ""}${value}%`).join(" — ") : `${winningBidPercentage > 0 ? "+" : ""}${winningBidPercentage}%`} ten opzichte van de vraagprijs**`
            ) : (
              "Je biedt **?% boven de vraagprijs**"
            )
          }
          titleColor="success"
          value={
            !!onWinningBidCTAClick || !!winningBidCTA ? null : (
              <BidValue value={onWinningBidCTAClick ? 0 : winningBid} />
            )
          }
        />
      </Grid>
      <Text
        align="center"
        color="currentColor50"
        markdown
        className={descriptionStyle}
      >
        {description}
      </Text>
      {bidCTA && <Columns>{bidCTA}</Columns>}
      {children}
    </Flex>
  );
};
